import React from 'react';

const TableSearch = ({
  value,
  onChange,
  placeholder = 'Search…',
  className = '',
}) => (
  <div className={`input-group ${className}`} style={{ maxWidth: 420 }}>
    <span className="input-group-text bg-white border-end-0">
      <i className="las la-search text-muted"></i>
    </span>
    <input
      type="search"
      className="form-control border-start-0 ps-0"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default TableSearch;
